import {gql} from "@apollo/client";

export const CreateCharacterSheet = gql`
    mutation CreateCharacterSheet($characterId: Int!, $languages: String, $spellAttackModifier: Int, $spellSaveDc: Int, $lifepoints: Int, $armorClass: Int, $initiative: Int) {
        createCharacterSheet(characterId: $characterId, languages: $languages, spellAttackModifier: $spellAttackModifier, spellSaveDc: $spellSaveDc, lifepoints: $lifepoints, armorClass: $armorClass, initiative: $initiative) {
            spellSaveDc
            characterSheetId
        }
    }
`

export const CreateCharacter = gql`
    mutation CreateCharacter($characterName: String!, $raceId: Int!, $subraceId: Int!, $userId: Int!, $adventureId: Int!, $subclassId: Int, $classId: Int) {
        createCharacter(characterName: $characterName, raceId: $raceId, subraceId: $subraceId, userId: $userId, adventureId: $adventureId, subclassId: $subclassId, classId: $classId) {
            characterName
            characterLevel
            characterId
            characterExp
        }
    }
`

export const UpdateCharacter = gql`
    mutation UpdateCharacter($characterId: Int!, $characterLevel: Int!, $characterExp: Int, $characterName: String!, $raceId: Int!, $subraceId: Int!, $userId: Int!, $adventureId: Int!) {
        updateCharacter(characterId: $characterId, characterLevel: $characterLevel, characterExp: $characterExp, characterName: $characterName, raceId: $raceId, subraceId: $subraceId, userId: $userId, adventureId: $adventureId) {
            characterId
        }
    }
`

export const LevelUpCharacter = gql`
    mutation LevelUpCharacter($characterId: Int!, $classId: Int!, $subclassId: Int) {
        levelUpCharacter(characterId: $characterId, classId: $classId, subclassId: $subclassId)
    }

`

export const UpdateCharacterSheet = gql`
    mutation UpdateCharacterSheet($characterSheetId: Int!, $characterId: Int!, $initiative: Int, $armorClass: Int, $lifepoints: Int, $languages: String, $spellAttackModifier: Int, $spellSaveDc: Int, $temporaryHitpoints: Int!, $currentHitpoints: Int, $currentMana: Int!, $gold: Int!, $silver: Int!) {
        updateCharacterSheet(characterSheetId: $characterSheetId, characterId: $characterId, initiative: $initiative, armorClass: $armorClass, lifepoints: $lifepoints, languages: $languages, spellAttackModifier: $spellAttackModifier, spellSaveDc: $spellSaveDc, currentHitpoints: $currentHitpoints, temporaryHitpoints: $temporaryHitpoints, currentMana: $currentMana, gold: $gold, silver: $silver) {
            characterSheetId
        }
    }
`

export const UpdateSkills = gql`
    mutation UpdateSkills($stc: [stc]) {
        updateSkill4Char(stc: $stc)
    }
`

export const UpdateAbilities = gql`
    mutation UpdateAbilities($atc: [atc]) {
        updateAbility4Char(atc: $atc)
    }
`

export const UpdateItems = gql`
    mutation UpdateItems($itemList: [itemList]!, $characterSheetId: Int!) {
        updateItems(itemList: $itemList, characterSheetId: $characterSheetId)
    }

`

export const UpdateSpells = gql`
    mutation UpdateSpells($spellList: [spellList]!, $characterSheetId: Int!) {
        updateSpells(spellList: $spellList, characterSheetId: $characterSheetId)
    }


`

export const UpdateNotes = gql`
    mutation UpdateNotes($noteList: [noteList]!, $characterSheetId: Int!) {
        updateNotes(noteList: $noteList, characterSheetId: $characterSheetId)
    }


`